<div id="weesign-content">
  <p style="text-align: center;">Cargando...</p>
</div>